import React from "react";
import CropWebpFaq from "./CropWebpFaq";
import CropWebpFreeContent from "./CropWebpFreeContent";
import { CropWebpFreeWithOnline } from "./CropWebpFreeWithOnline";

const CropWebpPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CropWebpFreeWithOnline />
                <CropWebpFreeContent />
                <CropWebpFaq />
            </div>
        </div>
    );
};

export default CropWebpPreToolsArea;
